import React from "react";
import styled from "styled-components";

export const PromptHeader = styled.header`
  font-family: montserrat;
  font-weight: bold;
  color: #a02200;
`;
